/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { Signature as ForcProviderBaseSignature } from "parog-web/components/forc/provider/base";
import type Patient from "parog-web/models/patient";
import eq from "ember-truth-helpers/helpers/eq";
import tnmClassificationCodes from "parog-web/helpers/tnm-classification-codes";

export interface Signature {
  Element: HTMLDivElement;
  Args: {
    Input?: unknown;
    TextArea?: unknown;
    Dropdown?: unknown;
    BasicRadioGroup?: unknown;
    Date?: unknown;
    patient: Patient;
    form: ForcProviderBaseSignature["Blocks"]["default"][0];
  };
}
export default class MedicalHistoryOncoBaseCancerForm extends Component<Signature> {
  eq = eq;
  tnmClassificationCodes = tnmClassificationCodes;
}
